import { render, staticRenderFns } from "./EventSelectionOddsRow.vue?vue&type=template&id=7ed10e20"
import script from "./EventSelectionOddsRow.vue?vue&type=script&lang=js"
export * from "./EventSelectionOddsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports